<!-- Copyright 2023 (Unpublished) Verto Inc. -->

<div class="header-container">
  <div class="header-logo-container">
    <a href="/">
      <img class="verto-logo" src="assets/images/verto-logo.png" />
    </a>
    <div class="d-flex flex-row" *ngIf="currentUser.token">
      <a
        routerLink="templates"
        type="button"
        class="btn btn-link ml-3 header-tab"
        [class.activated]="currentUrl && currentUrl.includes('templates')"
      >
        <span class="header-tab-text">Templates</span>
      </a>
      <a
        routerLink="packs"
        type="button"
        class="btn btn-link ml-3 header-tab"
        [class.activated]="currentUrl && currentUrl.includes('packs')"
      >
        <span class="header-tab-text">Packs</span>
      </a>
      <a
        routerLink="campaigns"
        type="button"
        class="btn btn-link ml-3 header-tab"
        [class.activated]="currentUrl && currentUrl.includes('campaigns')"
      >
        <span class="header-tab-text">Campaigns</span>
      </a>
      <a
        routerLink="workflows"
        type="button"
        class="btn btn-link ml-3 header-tab"
        [class.activated]="currentUrl && currentUrl.includes('workflows')"
      >
        <span class="header-tab-text">Workflows</span>
      </a>
      <a
        routerLink="visualizer"
        type="button"
        class="btn btn-link ml-3 header-tab"
        [class.activated]="currentUrl && currentUrl.includes('visualizer')"
      >
        <span class="header-tab-text">Visualizer</span>
      </a>
      <a
        routerLink="executions"
        type="button"
        class="btn btn-link ml-3 header-tab"
        [class.activated]="currentUrl && currentUrl.includes('executions')"
      >
        <span class="header-tab-text">Executions</span>
      </a>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-between">
    <div [class.hidden]="!currentUser.token" class="timezone-container">
      <div class="header-icon-text">Your timezone:</div>
      <p-dropdown
        (onChange)="onTimezoneSelectionChange()"
        [options]="timezoneOptions"
        optionLabel="name"
        [(ngModel)]="selectedTimezone"
      ></p-dropdown>
    </div>
    <div class="header-icons-container">
      <a [class.hidden]="!currentUser.token" class="header-icon" routerLink="/admin/credentials">
        <img class="icon" src="assets/images/settings-icon.png" />
        <div class="header-icon-text">Admin</div>
      </a>
      <a [class.hidden]="!currentUser.token" class="header-icon" href="#" (click)="logout()">
        <img class="icon" src="assets/images/exit-icon.png" />
        <div class="header-icon-text">Logout</div>
      </a>
      <mat-slide-toggle (change)="toggleDarkMode()" [(ngModel)]="checked"></mat-slide-toggle>
    </div>
  </div>
</div>
